export function useSiteOptions() {
  return { ...siteOptions };
}
